import clsx from 'clsx'

import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'

const Modal = ({ isOpen, handleCloseModal, title, isChart, children, hideClose = false, overflow = false }) => {
  return (
    <Dialog open={isOpen} onOpenChange={handleCloseModal}>
      <DialogContent
        className={clsx(
          'bg-background-general-light dark:bg-background-general-dark text-text-light dark:text-text-dark',
          {
            'max-w-full w-11/12': isChart,
          },
        )}
        hideClose={hideClose}
      >
        <DialogTitle className='text-text-light dark:text-text-dark shrink-0'>{title}</DialogTitle>
        <div className={clsx('', { 'flex-1': isChart, 'overflow-auto': overflow })}>{children}</div>
      </DialogContent>
    </Dialog>
  )
}
export default Modal
